export default {
  Class: 'class',
  Required: 'required',
  Novalidate: 'novalidate',
  Aria: {
    DescribedBy: 'aria-describedby',
    Required: 'aria-required',
    Invalid: 'aria-invalid',
  },
  Data: {
    ControlGroupFor: 'data-control-group-for',
    Tn: {
      Required: 'data-tn-required',
      BridgeFormKey: 'data-tn-bridge-form-key',
      BridgeFieldsetIndex: 'data-tn-bridge-fieldset-index',
    },
  },
};
